export default function utils() {
	return {
		validateStatus({ errors, pending, valid }) {
			if (errors[0]) return 'error';
			if (pending) return 'validating';
			if (valid) return '';
			return '';
		}
	};
}
